// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2F6mZ","bigColWidth":"Table_bigColWidth__Wcs4e","biggerColWidth":"Table_biggerColWidth__1Ns-m","row":"Table_row__2w2hg","col":"Table_col__39FuO"};